import { createRoot } from "react-dom/client";
import { HelmetProvider } from "react-helmet-async";
import App from "./App.tsx";
import "./index.css";
import "./styles/premium-polish.css";
import "./styles/phase2.css";
import "./i18n";

// Adopt static/prerendered SEO fallbacks so Helmet replaces them instead of
// appending a second homepage description, canonical or sharing URL.
document.head.querySelectorAll(
  'title, meta[name="description"], meta[name="author"], meta[name="robots"], meta[property^="og:"], meta[name^="twitter:"], link[rel="canonical"], link[hreflang]',
).forEach((tag) => tag.setAttribute("data-rh", "true"));

const root = document.getElementById("root");
if (!root) throw new Error("Application root is missing");

createRoot(root).render(
  <HelmetProvider>
    <App />
  </HelmetProvider>
);
